const dismissPropertyChecklist = () => ({
  type: 'PREFERENCES_PROPERTY_CHECKLIST_DISMISS'
})

export const preferencesActions = {
  dismissPropertyChecklist
}
